import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const ToolbarItemScaleIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22.3 5.8C22.56 6.06 23 5.88 23 5.51V1.69C23 1.31 22.69 1 22.31 1H18.49C18.12 1 17.94 1.44 18.2 1.7L19.8 3.3L18.68 4.41C16.89 2.83 14.55 1.86 11.99 1.86C9.43 1.86 7.08 2.83 5.3 4.41L4.19 3.3L5.79 1.7C6.05 1.44 5.87 1 5.5 1H1.69C1.31 1 1 1.31 1 1.69V5.51C1 5.88 1.44 6.06 1.7 5.8L3.3 4.2L4.41 5.31C2.83 7.1 1.86 9.44 1.86 12C1.86 14.56 2.83 16.91 4.41 18.69L3.3 19.81L1.7 18.21C1.44 17.95 1 18.13 1 18.5V22.32C1 22.7 1.31 23.01 1.69 23.01H5.51C5.88 23.01 6.06 22.57 5.8 22.31L4.2 20.71L5.31 19.6C7.1 21.18 9.44 22.15 12 22.15C14.56 22.15 16.91 21.18 18.69 19.6L19.8 20.71L18.2 22.31C17.94 22.57 18.12 23.01 18.49 23.01H22.31C22.69 23.01 23 22.7 23 22.32V18.5C23 18.13 22.56 17.95 22.3 18.21L20.7 19.81L19.59 18.7C21.17 16.91 22.14 14.57 22.14 12.01C22.14 9.45 21.17 7.1 19.59 5.32L20.7 4.21L22.3 5.81V5.8ZM21.12 12C21.12 14.29 20.27 16.38 18.87 17.99L18.4 17.52C18.16 17.28 17.76 17.28 17.52 17.52C17.28 17.76 17.28 18.16 17.52 18.4L17.99 18.87C16.39 20.27 14.3 21.12 12 21.12C9.7 21.12 7.62 20.26 6.01 18.87L6.48 18.4C6.72 18.16 6.72 17.76 6.48 17.52C6.24 17.28 5.84 17.28 5.6 17.52L5.13 17.99C3.73 16.39 2.88 14.29 2.88 12C2.88 9.71 3.74 7.62 5.13 6.01L5.6 6.48C5.84 6.72 6.24 6.72 6.48 6.48C6.72 6.24 6.72 5.84 6.48 5.6L6.01 5.13C7.61 3.73 9.71 2.88 12 2.88C14.29 2.88 16.38 3.73 17.99 5.13L17.52 5.6C17.28 5.84 17.28 6.24 17.52 6.48C17.76 6.72 18.16 6.72 18.4 6.48L18.87 6.01C20.27 7.61 21.12 9.71 21.12 12Z"
        fill={color}
      />
      <path
        d="M12.38 7.35C12.15 7.21 11.86 7.21 11.63 7.35L8.19001 9.35C7.96001 9.48 7.82001 9.73 7.82001 10V14C7.82001 14.27 7.96001 14.51 8.19001 14.65L11.63 16.65C11.86 16.79 12.15 16.79 12.38 16.65L15.82 14.65C16.05 14.52 16.19 14.27 16.19 14V10C16.19 9.73 16.05 9.49 15.82 9.35L12.38 7.35ZM14.69 13.57L12 15.13L9.31001 13.57V10.43L12 8.87L14.69 10.43V13.57Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ToolbarItemScaleIcon.displayName = 'ToolbarItemScaleIcon';
